import { styled } from '@aether/styles'
import { InsiderPage } from '@aether/models'

interface BenefitsProps {
  benefits: InsiderPage['benefits']
}

const Container = styled('section', {
  width: '100%',
  maxWidth: '$containerSizeM',
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
})

const Title = styled('h2', {
  $aetherFont: 'heading02',
  paddingTop: 0,
  marginBottom: '$48',

  '@md': {
    marginBottom: '$56',
  },
})

const BenefitsGrid = styled('div', {
  display: 'grid',
  gridTemplateColumns: '1fr',
  rowGap: '$32',
  columnGap: '$20',

  '@md': {
    gridTemplateColumns: 'repeat(3, 1fr)',
  },
})

const BenefitNumber = styled('div', {
  border: '1px solid $gray_light_second',
  backgroundColor: '$white',
  borderRadius: '$rMax',
  position: 'absolute',
  top: '-$16',
  left: '$24',
  width: '$32',
  height: '$32',
  $aetherFont: 'body02',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'all 0.2s ease-in-out',
  textAlign: 'center',

  '& span': {
    transform: 'translateX(1px)',
  },
})

const BenefitTitle = styled('h3', {
  $aetherFont: 'heading05',
  marginBottom: '$12',
  transition: 'color 0.2s ease-in-out',
})

const BenefitCard = styled('div', {
  border: '1px solid $gray_light_second',
  borderRadius: '10px',
  padding: '$32 $24',
  position: 'relative',

  '&:hover': {
    [`${BenefitNumber}`]: {
      backgroundColor: '$blue',
      color: '$white',
      borderColor: '$blue',
    },

    [`${BenefitTitle}`]: {
      color: '$blue',
    },
  },
})

const BenefitDescription = styled('p', {
  $aetherFont: 'body02',
  color: '$gray700',
})

export const Benefits = ({ benefits }: BenefitsProps) => {
  if (!benefits?.items?.length) return null

  return (
    <Container>
      {benefits.title && <Title>{benefits.title}</Title>}
      <BenefitsGrid>
        {benefits.items.map((item, index) => (
          <BenefitCard key={`${item.title}-${index}`}>
            <BenefitNumber>
              <span>{index + 1}</span>
            </BenefitNumber>
            {item.title && <BenefitTitle>{item.title}</BenefitTitle>}
            {item.description && (
              <BenefitDescription>{item.description}</BenefitDescription>
            )}
          </BenefitCard>
        ))}
      </BenefitsGrid>
    </Container>
  )
}
